module.exports = __webpack_public_path__ + "img/logo-mini.fa14c0d8.svg";